import { Injectable } from '@angular/core';
import { ApiRequestService } from '@core/services/api-request.service';
import { config } from '@core/services/request-url.service';
import { NgxToasterService } from '@core/services/toasterNgs.service';
import {BehaviorSubject, map, Observable, shareReplay, Subscription} from 'rxjs';
import { QrListApiResponse, RecentTransactionsApiResponse } from './payin.types';

@Injectable({
  providedIn: 'root'
})
export class PayinService {
  vpaListSubs: Subscription;
  recentTransactionSubs: Subscription;
  statusWiseAmountSubs: Subscription;
  volumeGraphSubs: Subscription;
  qrListSubs: Subscription;
  vpaListData: BehaviorSubject<any> = new BehaviorSubject('');
  vpaDataList: BehaviorSubject<any> = new BehaviorSubject([]);
  recentTransactions: BehaviorSubject<any> = new BehaviorSubject([]);
  statusWiseAmount: BehaviorSubject<any> = new BehaviorSubject('');
  volumeGraph: BehaviorSubject<any> = new BehaviorSubject([]);
  qrList: BehaviorSubject<any> = new BehaviorSubject('');
  constructor(
    private _apiRequestService: ApiRequestService,
    private _NgxToasterService: NgxToasterService,
  ) {}

  get _vpaListData$() {
    return this.vpaListData.asObservable();
  }

  get _recentTransactions$() {
    return this.recentTransactions.asObservable();
  }
  get _statusWiseAmount$() {
    return this.statusWiseAmount.asObservable();
  }

  get _volumeGraph$() {
    return this.volumeGraph.asObservable();
  }

  get _qrList$() {
    return this.qrList.asObservable();
  }

  get _qrListObject() {
    return this.qrList.getValue();
  }

  getVpaList(search?:any, start:any = 0): Promise<void> {
    return new Promise((res, rej) => {
      let formdata = new FormData();
      formdata.append("start", start);
      formdata.append("length", '10');
      formdata.append('sort', 'desc');
      formdata.append('sortBy', 'updated_at');
   if(search !== undefined)   formdata.append('search', search);
   this.vpaListSubs = this._apiRequestService.postdataAdmin(formdata, config['payin'].vpaList).subscribe((resp: any) => {
          if (resp.statuscode == 200) {
            this.vpaListData.next(resp.data);
            res(resp.data);
          } else {
            this.vpaListData.next([]);
            this._NgxToasterService.showError(resp.message, 'Error');
            rej(false);
          }
        });
    });
  }

  private settlementDetails$: BehaviorSubject<any>;

  InitSettlementDetails(payload: any) {
    if (!this.settlementDetails$) {
      this.settlementDetails$ = new BehaviorSubject<any>(null);
      this._apiRequestService.postdataAdmin(payload, config['payin'].settlementDetails).subscribe((resp: any) => {
        if (resp.statuscode == 200) {
          this.settlementDetails$.next(resp.data);
        } else {
          this.settlementDetails$.next([]);
          this._NgxToasterService.showError(resp.message, 'Error');
        }
      });
    }
  }
  FetchSettlementDetails(): Observable<any> {
    return this.settlementDetails$.asObservable();
  }

  getRecentTransactions(payload?:any){
    let formData: FormData = new FormData();
    formData.append('type', (payload?.type ? payload?.type: 'recent'))
    formData.append('limit', '5')
    if(payload?.vpa) formData.append('vpa', payload?.vpa)
      this.recentTransactionSubs =  this._apiRequestService.postdata(formData, config['payin'].getRecentTransactions).subscribe((res: RecentTransactionsApiResponse) => {
      if (res.statuscode =='200') {
        this.recentTransactions.next(res)
      } else {
        this.recentTransactions.next([])
        this._NgxToasterService.showError(res.message, 'Error');
      }
    });
  }

  getstatusWiseAmount(payload:any = null){
    this.statusWiseAmountSubs = this._apiRequestService.postdata(payload, config['payin'].statusWiseAmount).subscribe((res: any) => {
      if (res.statuscode === 200) {
        this.statusWiseAmount.next(res)
      } else {
        this.statusWiseAmount.next('')
        this._NgxToasterService.showError(res.message, 'Error');
      }
    });
  }

  getVolumeGraph(payload?:any) {
    let formData: FormData = new FormData();
      formData.append('mode', 'all');
      formData.append('type',  (payload?.dateType ? payload?.dateType: 'day'));
      this.volumeGraphSubs =   this._apiRequestService.postdata(formData, config['payin'].volumeGraph).subscribe({
        next: (resp: any) => {
          if (resp.statuscode === 200) {
            this.volumeGraph.next(resp)
          } else {
            this.volumeGraph.next([]);
          }
        }, error: (err: any) => {
          this.volumeGraph.next([]);
          this._NgxToasterService.showError(err.message, "Error")
        }
        })

    };

    getQRList(from_date: string = '', to_date: string = '', vpaKey:string='', search:string='') {
      let formData: FormData = new FormData();
      formData.append('fromDate', from_date)
      formData.append('toDate', to_date)
      formData.append('vpa', vpaKey)
       if(search !== '')   formData.append('search', search)
        this.qrListSubs =   this._apiRequestService.postdata(formData, config['payin'].QrList).subscribe({
          next: (resp: QrListApiResponse) => {
            if (resp.statuscode =='200') {
              this.qrList.next(resp.data)
            } else {
              this.qrList.next([]);
            }
          }, error: (err: any) => {
            this.qrList.next([]);
            this._NgxToasterService.showError(err.message, "Error")
          }
          })

      };


    loadPayinDashboard() {
      if (!this.recentTransactions.getValue()) {
        this.getRecentTransactions();
      }
      if (!this.statusWiseAmount.getValue()) {
        this.getstatusWiseAmount();
      }
      if (!this.volumeGraph.getValue()) {
        this.getVolumeGraph();
      }
      // if (!this.vpaListData.getValue()) {
      //   this.getVpaList();
      // }
    }


    ngOnDestroy(): void {
      if (this.vpaListSubs) {
        this.vpaListSubs.unsubscribe();
      }
      if (this.recentTransactionSubs) {
        this.recentTransactionSubs.unsubscribe();
      }
      if (this.statusWiseAmountSubs) {
        this.statusWiseAmountSubs.unsubscribe();
      }
      if (this.volumeGraphSubs) {
        this.volumeGraphSubs.unsubscribe();
      }
      if (this.qrListSubs) {
        this.qrListSubs.unsubscribe()
      }
    };

    resetPayinBehaviours() {
      this.vpaListData.next(null);
      this.vpaDataList.next(null);
      this.recentTransactions.next(null);
      this.statusWiseAmount.next(null);
      this.volumeGraph.next(null);
      this.qrList.next(null);
    }

}
